import * as React from 'react';
import { useStore } from 'zustand';
import { PredicateStoreContext } from '../context';

export const usePredicateStoreDeletePredicatePart = () => {
    const { store } = React.useContext(PredicateStoreContext);
    if (!store) throw new Error('Missing PredicateStoreContext.Provider in the tree');
    const deletePredicatePart = useStore(store, (s) => s.deletePredicatePart);

    return deletePredicatePart;
};
